module.exports = __webpack_public_path__ + "static/media/rBearPat.9585f3d2.png";